import { render, staticRenderFns } from "./En_life.vue?vue&type=template&id=8b4235bc&scoped=true"
import script from "./En_life.vue?vue&type=script&lang=js"
export * from "./En_life.vue?vue&type=script&lang=js"
import style0 from "./En_life.vue?vue&type=style&index=0&id=8b4235bc&prod&scoped=true&lang=css"
import style1 from "./En_life.vue?vue&type=style&index=1&id=8b4235bc&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b4235bc",
  null
  
)

export default component.exports